import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmCancelEditTicket = (props) => {
    useTranslationSubscription();
    const { detailTicket, handleResetFormData, setCloseTabIdState, handleCancelTicket, isConfirmCancelEditTicket} = props;

    // Cancel
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmCancelEditTicket(false);
        setCloseTabIdState(0)
    };

    // Handle save draft
    const handlerClearDraft = () => {
        props.setIsConfirmCancelEditTicket(false);
        handleResetFormData();
    }

    return (
        <Dialog
            open={isConfirmCancelEditTicket}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {trI18n('MSG-CM-CONFIRM-CANCEL-DATA-CHANGE')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={() => {
                        if (detailTicket.public === Constant.TICKET_PUBLIC.PUBLIC) {
                            handleCancelTicket()
                            return;
                        }
                        if (detailTicket.public === Constant.TICKET_PUBLIC.DRAFT) {
                            handlerClearDraft();
                            return;
                        }
                    }}
                >
                    {trI18n('CM-BUTTON-OK')}
                </Button>

               <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('CM-BUTTON-CANCEL')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

DialogConfirmCancelEditTicket.propTypes = {
    detailTicket: PropTypes.object,
    handleResetFormData: PropTypes.func,
    setCloseTabIdState: PropTypes.func,
    isConfirmCancelEditTicket: PropTypes.bool,
    handleCancelTicket: PropTypes.func
}